export default "__VITE_ASSET__fjW_OjAE__"